module.exports = __webpack_public_path__ + "hotels-src-icon.png?a81e1de72d0b6b064f49ae8dc3cf72c4";